import { useState, useCallback } from 'react';

export default function useMultiSelect() {
  const [isMultiSelectMode, setIsMultiSelectMode] = useState(false);
  const [selectedClipIds, setSelectedClipIds] = useState<Set<string>>(new Set());

  const enterMultiSelectMode = useCallback(() => {
    setIsMultiSelectMode(true);
    setSelectedClipIds(new Set());
  }, []);

  const exitMultiSelectMode = useCallback(() => {
    setIsMultiSelectMode(false);
    setSelectedClipIds(new Set());
  }, []);

  const toggleClipSelection = useCallback((clipId: string) => {
    setSelectedClipIds(prev => {
      const next = new Set(prev);
      if (next.has(clipId)) {
        next.delete(clipId);
      } else {
        next.add(clipId);
      }
      return next;
    });
  }, []);

  return {
    isMultiSelectMode,
    selectedClipIds,
    enterMultiSelectMode,
    exitMultiSelectMode,
    toggleClipSelection
  };
}
